import { alpha } from "@mui/material/styles";
import BaseRatioBarCell from "@plannel/components/aggrid/RatioBarCell";
import ColorUtil from "@plannel/pages/utils/color-util";

/*
 * DW 대시보드 ag-grid 공용 관용구.
 * 레퍼런스: pages/dashboard/SalesStatusDashboard.js 의 상위 거래처 테이블.
 */

/*
 * 대시보드 테이블 기본 colDef — 읽기 전용 랭킹 테이블 성격(정렬/이동/메뉴 없음).
 *   폭만 예외로 사용자가 끌어서 바꿀 수 있게 둔다(`resizable`) — 거점명·품목명이 길어 잘리는 칸을
 *   그 자리에서 넓혀 보려는 요구가 실제로 있었다. 열 이동(suppressMovable)은 계속 막는다.
 *   ⚠ 각 컬럼이 `flex` 를 쓰므로, 사용자가 폭을 끌면 그 컬럼만 flex 를 잃고 고정폭이 된다
 *     (ag-grid 규정 동작). 나머지 flex 컬럼이 남은 폭을 다시 나눠 가진다. `minWidth` 는 그대로 하한.
 *   폭 저장(p13n)은 하지 않는다 — 화면을 다시 열면 기본 배분으로 돌아온다.
 */
export const dashboardDefaultColDef = {
  resizable: true, sortable: false, suppressMovable: true,
  suppressHeaderMenuButton: true, wrapHeaderText: true, autoHeaderHeight: true,
};

export const DASHBOARD_ROW_HEIGHT = 30;
export const HIGHLIGHT_ROW_CLASS = "dash-hl";

/*
 * 행 클릭 + 하이라이트 연동용 sx (Box.className="ag-theme-balham" 에 적용).
 * 하이라이트 색은 primary 기반 — 라이트에서 기존 rgba(4,139,168,0.14) 와 동일.
 *
 * ★ `clickable` — **행이 실제로 눌리는 표에서만 포인터 커서를 준다.**
 *   예전엔 무조건 `cursor: pointer` 였다. 그러면 행 드릴이 없는 표(PSI Balance)나
 *   **계층 롤업 중이라 드릴을 꺼 둔 표**(Inventory·Supply Trend 의 그룹 행)에서도 커서만 바뀌어,
 *   **눌릴 것처럼 보이는데 아무 일도 안 일어난다.** 어포던스가 거짓말을 하는 쪽이 없는 것보다 나쁘다.
 *   기본값은 `true` 라 기존 호출부는 그대로 동작한다(하위호환).
 */
export const dashboardGridSx = (theme, clickable = true) => ({
  flex: 1, minHeight: 0, width: "100%",
  ...(clickable ? { "& .ag-row": { cursor: "pointer" } } : {}),
  [`& .ag-row.${HIGHLIGHT_ROW_CLASS}`]: {
    backgroundColor: `${alpha(theme.palette.primary.main, 0.14)} !important`,
  },
});

// 셀 내 비중 막대 — 행 순위 색을 ColorUtil 팔레트에서 **행마다** 가져온다. 여기서만 행별 색인 이유는
// 같은 카드의 지도 마커·차트 시리즈가 같은 순위 색을 쓰기 때문 — 표와 지도를 눈으로 잇는 게 색이다.
// (공용 RatioBarCell 의 기본값은 행 수와 무관한 단색이라, 그 연동이 필요한 여기서만 color 를 넘긴다.)
// 그리는 일은 공용 RatioBarCell 이 하고, 여기선 대시보드용 기본값(얇은 막대 + 라벨 우측)만 고정한다.
export const RatioBarCell = (p) => (
  <BaseRatioBarCell {...p} color={ColorUtil.colorSet(p.node?.rowIndex ?? 0)} labelPlacement="right" barHeight={8} />
);
